import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {WeekRepository} from './repositories/week.repository';
import {WeekService} from './services/week.service';

import {LeadaComponentsModule} from 'shared/components/leada-components.module';
import { InsightsPage } from './components/insights-page/insights-page';
import { PerformancePanel } from './components/performance-panel/performance-panel';
import { RecreationPanel } from './components/recreation-panel/recreation-panel';
import { ResiliencePanel } from './components/resilience-panel/resilience-panel';
import {StatusIndicator} from './components/status-indicator/status-indicator';
import {StatusRepository} from './repositories/status.repository';
import {StatusService} from './services/status.service';
import { MonitoringPage } from './components/monitoring-page/monitoring-page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild([
      { path: '', component: InsightsPage },
      { path: 'monitoring', component: MonitoringPage },
    ]),
    TranslateModule,
    LeadaComponentsModule,
  ],
  providers: [
    WeekRepository,
    WeekService,
    StatusRepository,
    StatusService,
  ],
  declarations: [
    InsightsPage,
    ResiliencePanel,
    PerformancePanel,
    RecreationPanel,
    StatusIndicator,
    MonitoringPage,
  ],
  // entryComponents: [
  //   InsightsPage,
  // ],
})
export class InsightsModule { }
